module.exports = __webpack_public_path__ + "static/img/E001.6c8a1c2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/E001.jpg
// module id = aCrX
// module chunks = 1